import * as React from "react";

interface Props {
  style?: React.CSSProperties;
  className?: string;
}
export const GvcIcon: React.FC<Props> = ({ style = {}, className = "" }) => {
  return (
    <svg
      style={style}
      className={className}
      id="Capa_1"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="m432 145c-1.904 0-3.803.068-5.694.203-5.7-18.177-16.413-34.576-31.023-47.19-19.639-16.957-45.07-25.904-71.086-24.942-25.498-44.711-73.167-73.071-124.197-73.071-64.102 0-120.825 44.057-137.853 105.863-36.893 16.4-61.147 53.241-61.147 94.137 0 39.874 22.775 74.526 56 91.636v-37.636c0-24.813 20.187-45 45-45h308c24.814 0 45 20.187 45 45v45.569c32.376-9.873 56-40.006 56-75.569 0-43.561-35.44-79-79-79z" />
        <path d="m410 239h-308c-8.284 0-15 6.716-15 15v105.944h338v-105.944c0-8.284-6.717-15-15-15zm-194.385 77h-79.615c-8.284 0-15-6.716-15-15s6.716-15 15-15h79.615c8.283 0 15 6.716 15 15s-6.717 15-15 15zm96.385-.144c-8.284 0-15-6.716-15-15s6.716-15 15-15c8.283 0 15 6.716 15 15s-6.717 15-15 15zm64 0c-8.284 0-15-6.716-15-15s6.716-15 15-15c8.283 0 15 6.716 15 15s-6.717 15-15 15z" />
        <path d="m87 497c0 8.284 6.716 15 15 15h308c8.283 0 15-6.716 15-15v-107.056h-338zm289-65c8.283 0 15 6.716 15 15s-6.717 15-15 15c-8.284 0-15-6.716-15-15s6.716-15 15-15zm-64 0c8.283 0 15 6.716 15 15s-6.717 15-15 15c-8.284 0-15-6.716-15-15s6.716-15 15-15zm-176 0h79.615c8.283 0 15 6.716 15 15s-6.717 15-15 15h-79.615c-8.284 0-15-6.716-15-15s6.716-15 15-15z" />
      </g>
    </svg>
  );
};
